import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { ROUTES, useAdvancedNavigate } from '@cyberint/common-utils';
import Icons from '../Icons';
import { Breadcrumbs } from '../Link';
import { useCardLayout } from './CardLayoutContext';
import * as S from './CardLayoutStyled';

export const CardLayoutDefaultToolbar = ({ customerName, crumbs, showBackArrow, showFullScreenToggle = true }) => {
  const { state } = useLocation();
  const navigate = useAdvancedNavigate();
  const goBack = () => navigate(-1);

  const ctx = useCardLayout();
  const { isFullScreen, fullScreenHandler, closeHandler } = ctx || {};

  const shouldShowBackArrow = showBackArrow ?? !!state?.[ROUTES.DRILL_DOWN];

  return (
    <S.ToolbarWrapper>
      <Breadcrumbs customerName={customerName} crumbs={crumbs} />
      <S.ButtonsWrapper>
        {shouldShowBackArrow && <Icons.ArrowDirection onClick={goBack} />}
        {showFullScreenToggle &&
          (isFullScreen ? (
            <Icons.Shrink onClick={fullScreenHandler} data-testid="button-toggle-fullscreen_off" />
          ) : (
            <Icons.Expand onClick={fullScreenHandler} data-testid="button-toggle-fullscreen_on" />
          ))}
        <Icons.Close onClick={closeHandler} data-testid="button-close-dialog" />
      </S.ButtonsWrapper>
    </S.ToolbarWrapper>
  );
};

CardLayoutDefaultToolbar.propTypes = {
  customerName: PropTypes.string,
  crumbs: PropTypes.arrayOf(PropTypes.string),
  showBackArrow: PropTypes.bool,
  showFullScreenToggle: PropTypes.bool
};
